import React from "react";
import { Section, SectionHeading } from "./Section";
import { CTAButton } from "./CTAButton";
import { tools } from "../data/tools";
export function Tools() {
  return <Section tone="cream" data-id="element-238" data-mp="17ejis3l0u5au">
      <SectionHeading eyebrow="More than six educational volumes" title="Practical Reference Tools to Complement Your Clinical Roadmap" intro={["The collection also includes a range of practical resources designed to help you organize your learning and professional documentation."]} data-id="element-239" data-mp="17fbedeemc314" />

      <ul className="mx-auto mt-12 max-w-4xl divide-y divide-navy-900/10 rounded-3xl bg-white px-6 md:px-10" data-id="element-240" data-mp="243r7tlkumwji">
        {tools.map(({
        icon: Icon,
        title,
        body
      }) => <li key={title} className="flex items-start gap-5 py-6" data-id="element-241" data-mp="1vc8rnanwkgqf">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy-900 text-gold-400" data-id="element-242" data-mp="1vae37mdfa6hl">
              <Icon className="h-6 w-6" aria-hidden data-id="element-243" data-mp="2nst9h4cqk64u" />
            </span>
            <div data-id="element-244" data-mp="2nuw6478e8xij">
              <h3 className="text-lg font-bold uppercase tracking-wide text-navy-900" data-id="element-245" data-mp="2p1npcoopl595">{title}</h3>
              <p className="mt-1.5 text-[16px] leading-relaxed text-navy-900/75" data-id="element-246" data-mp="2l02grfj7jd4r">{body}</p>
            </div>
          </li>)}
      </ul>

      <p className="mx-auto mt-8 max-w-2xl text-center text-[17px] leading-relaxed text-navy-900/75" data-id="element-247" data-mp="2ysim4mzkzn8u">
        Everything is designed to complement the six volumes and create a more cohesive professional reference library.
      </p>

      <CTAButton label="Get the complete Facial Aesthetics Clinical Roadmap™" note="One-time payment · Digital collection · $27 USD" data-id="element-248" data-mp="38ntveps80297" />
    </Section>;
}